// The WebMCP loader (js/webmcp.js) reads this before it downloads the tools,
// so this module must not import the tools or their data.
export function resolveModelContext(globals = globalThis) {
  const documentContext = globals.document?.modelContext;
  if (documentContext && typeof documentContext.registerTool === 'function') {
    return documentContext;
  }
  const navigatorContext = globals.navigator?.modelContext;
  if (navigatorContext && typeof navigatorContext.registerTool === 'function') {
    return navigatorContext;
  }
  return null;
}
